"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisTriggerExecutionSchema = exports.AnalysisTriggerSchema = exports.analysisTriggerAccessors = exports.analysisTriggerFilterSchema = exports.AnalysisTriggerFilterDefinitionSchema = exports.AnalysisTriggerFilterFindingContinuitySchema = exports.AnalysisTriggerFilterFunctionSchema = exports.AnalysisTriggerContextSchema = exports.AnalysisTriggerInvokerSchema = exports.AnalysisTriggerSubjectDefinitionSchema = exports.AnalysisTriggerSubjectRefSchema = exports.AnalysisTriggerLoadedSubjectSchema = exports.AnalysisTriggerSubjectIdentitySchema = exports.AnalysisTriggerSubjectSchema = exports.AnalysisTriggerFindingRefSchema = exports.AnalysisTriggerPackageSubjectDataSchema = exports.AnalysisTriggerPackageModuleRefSchema = exports.AnalysisTriggerModuleBomSnapshotSchema = exports.AnalysisTriggerSubjectCustomTypeDefinitionSchema = void 0;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const QueryBuilder_1 = require("../QueryBuilder");
const agent_executor_1 = require("./executors/agent-executor");
const lifecycle_1 = require("./lifecycle");
const trigger_executor_1 = require("./trigger-executor");
exports.AnalysisTriggerSubjectCustomTypeDefinitionSchema = zod_1.default.object({
    customTypeName: zod_1.default.string(),
    subjectName: zod_1.default.string(),
    description: zod_1.default.string(),
    properties: zod_1.default.record(zod_1.default.string(), zod_1.default.unknown()).optional(),
});
exports.AnalysisTriggerModuleBomSnapshotSchema = zod_1.default.object({
    bomItemId: zod_1.default.string(),
    moduleId: zod_1.default.string().nullable().optional(),
    referenceDesignator: zod_1.default.string(),
    isReviewed: zod_1.default.boolean(),
    resolutionType: zod_1.default.enum(['sigmaModel', 'packageStore', 'nonElectrical']).nullable().optional(),
    sigmaModelType: zod_1.default.string().nullable().optional(),
    packageId: zod_1.default.string().nullable().optional(),
    parameters: zod_1.default.unknown().optional(),
    signalMap: zod_1.default.record(zod_1.default.string(), zod_1.default.unknown()).optional(),
    isDnp: zod_1.default.boolean().nullable().optional(),
    manufacturerPartNumber: zod_1.default.string().nullable().optional(),
    manufacturerId: zod_1.default.string().nullable().optional(),
    manufacturerName: zod_1.default.string().nullable().optional(),
    datasheetFileId: zod_1.default.string().nullable().optional(),
    moduleDatasheetFileId: zod_1.default.string().nullable().optional(),
    moduleDatasheetUrl: zod_1.default.string().nullable().optional(),
    packageUnderstood: zod_1.default.boolean().nullable().optional(),
    packagePinCount: zod_1.default.number().int().nonnegative().nullable().optional(),
});
exports.AnalysisTriggerPackageModuleRefSchema = zod_1.default.object({
    bomItemId: zod_1.default.string(),
    moduleId: zod_1.default.string().nullable(),
    referenceDesignator: zod_1.default.string(),
});
exports.AnalysisTriggerPackageSubjectDataSchema = zod_1.default.object({
    packageId: zod_1.default.string(),
    sigmaModelType: zod_1.default.string(),
    modules: zod_1.default.array(exports.AnalysisTriggerPackageModuleRefSchema),
});
exports.AnalysisTriggerFindingRefSchema = zod_1.default.object({
    findingId: zod_1.default.string(),
});
exports.AnalysisTriggerSubjectSchema = zod_1.default.discriminatedUnion('typeName', [
    zod_1.default.object({
        typeName: zod_1.default.literal('module'),
        data: zod_1.default.object({
            module: sigma_engine_shared_1.DesignModels.ProjectModuleSchema,
            instances: zod_1.default.array(sigma_engine_shared_1.DesignModels.ModuleSchema),
            bomItem: exports.AnalysisTriggerModuleBomSnapshotSchema,
        }),
    }),
    zod_1.default.object({ typeName: zod_1.default.literal('net'), data: sigma_engine_shared_1.DesignModels.NetInfoSchema }),
    zod_1.default.object({ typeName: zod_1.default.literal('schematic'), data: sigma_engine_shared_1.DesignModels.SchematicModelSchema }),
    zod_1.default.object({ typeName: zod_1.default.literal('project'), data: sigma_engine_shared_1.DesignModels.ProjectModelSchema }),
    zod_1.default.object({ typeName: zod_1.default.literal('package'), data: exports.AnalysisTriggerPackageSubjectDataSchema }),
    zod_1.default.object({
        typeName: zod_1.default.literal('packageStorePageModule'),
        packageId: zod_1.default.string(),
        data: zod_1.default.object({ module: sigma_engine_shared_1.DesignModels.ProjectModuleSchema, instances: zod_1.default.array(sigma_engine_shared_1.DesignModels.ModuleSchema) }),
    }),
    zod_1.default.object({
        typeName: zod_1.default.literal('custom'),
        customTypeName: zod_1.default.string(),
        data: exports.AnalysisTriggerSubjectCustomTypeDefinitionSchema,
    }),
    zod_1.default.object({
        typeName: zod_1.default.literal('finding'),
        data: exports.AnalysisTriggerFindingRefSchema,
    }),
]);
exports.AnalysisTriggerSubjectIdentitySchema = zod_1.default.object({
    subjectType: zod_1.default.enum([
        'module',
        'net',
        'schematic',
        'project',
        'package',
        'packageStorePageModule',
        'custom',
        'finding',
    ]),
    subjectKey: zod_1.default.string(),
    subjectFingerprint: zod_1.default.string(),
});
exports.AnalysisTriggerLoadedSubjectSchema = zod_1.default.object({
    identity: exports.AnalysisTriggerSubjectIdentitySchema,
    subject: exports.AnalysisTriggerSubjectSchema,
});
exports.AnalysisTriggerSubjectRefSchema = zod_1.default.object({
    subjectType: exports.AnalysisTriggerSubjectIdentitySchema.shape.subjectType,
    subjectKey: zod_1.default.string(),
});
exports.AnalysisTriggerSubjectDefinitionSchema = zod_1.default.discriminatedUnion('typeName', [
    zod_1.default.object({ typeName: zod_1.default.literal('module') }),
    zod_1.default.object({ typeName: zod_1.default.literal('net') }),
    zod_1.default.object({ typeName: zod_1.default.literal('schematic') }),
    zod_1.default.object({ typeName: zod_1.default.literal('project') }),
    zod_1.default.object({ typeName: zod_1.default.literal('package') }),
    zod_1.default.object({ typeName: zod_1.default.literal('packageStorePageModule'), packageId: zod_1.default.string() }),
    zod_1.default.object({ typeName: zod_1.default.literal('custom'), customTypeName: zod_1.default.string() }),
    zod_1.default.object({ typeName: zod_1.default.literal('finding') }),
]);
exports.AnalysisTriggerInvokerSchema = zod_1.default.discriminatedUnion('kind', [
    zod_1.default.object({ kind: zod_1.default.literal('user'), userId: zod_1.default.string() }),
    zod_1.default.object({ kind: zod_1.default.literal('system'), reason: zod_1.default.string() }),
]);
exports.AnalysisTriggerContextSchema = zod_1.default
    .object({
    projectId: zod_1.default.string().optional(),
    buildId: zod_1.default.string().optional(),
    projectModelId: zod_1.default.string().optional(),
    ownerId: zod_1.default.string().optional(),
    invoker: exports.AnalysisTriggerInvokerSchema,
    analysisRunId: zod_1.default.string().optional(),
})
    .passthrough();
exports.AnalysisTriggerFilterFunctionSchema = zod_1.default.object({
    type: zod_1.default.literal('func'),
    func: zod_1.default.custom((value) => typeof value === 'function'),
});
exports.AnalysisTriggerFilterFindingContinuitySchema = zod_1.default.object({
    type: zod_1.default.literal('finding_continuity'),
});
exports.AnalysisTriggerFilterDefinitionSchema = zod_1.default.discriminatedUnion('type', [
    exports.AnalysisTriggerFilterFunctionSchema,
    exports.AnalysisTriggerFilterFindingContinuitySchema,
]);
const EXACT_STRING_FILTER_OPERATORS = ['equals', 'is', 'isAnyOf', 'not', 'doesNotEqual'];
const OPTIONAL_EXACT_STRING_FILTER_OPERATORS = [
    ...EXACT_STRING_FILTER_OPERATORS,
    'isEmpty',
    'isNotEmpty',
];
const TEXT_ID_FILTER_OPERATORS = [
    ...EXACT_STRING_FILTER_OPERATORS,
    'contains',
    'startsWith',
    'endsWith',
    'isEmpty',
    'isNotEmpty',
];
exports.analysisTriggerFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        triggerId: {
            description: 'Trigger id.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: EXACT_STRING_FILTER_OPERATORS,
        },
        lifecycleStage: {
            description: 'Lifecycle stage: package-understanding, pre-analysis, analysis, or post-analysis.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: EXACT_STRING_FILTER_OPERATORS,
        },
        runPolicy: {
            description: 'When the trigger runs: automatic (every analysis pass) or on_demand (only runs that include on-demand triggers).',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: EXACT_STRING_FILTER_OPERATORS,
        },
        subjectType: {
            description: 'Subject type the trigger runs against: module, net, schematic, project, package, packageStorePageModule, custom, or finding.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: EXACT_STRING_FILTER_OPERATORS,
        },
        customTypeName: {
            description: 'Custom subject type name, only present when subjectType is custom.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: OPTIONAL_EXACT_STRING_FILTER_OPERATORS,
        },
        packageId: {
            description: 'Package id, only present when subjectType is packageStorePageModule.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: OPTIONAL_EXACT_STRING_FILTER_OPERATORS,
        },
        executorType: {
            description: 'Trigger executor type, such as agent.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: EXACT_STRING_FILTER_OPERATORS,
        },
        agentId: {
            description: 'Agent id for agent-backed triggers, such as cadstrom-project-assistant.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: TEXT_ID_FILTER_OPERATORS,
        },
        filterType: {
            description: 'Trigger filter type, such as func. Empty when the trigger has no filter.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: OPTIONAL_EXACT_STRING_FILTER_OPERATORS,
        },
        hasFilter: {
            description: 'True when the trigger has a subject filter.',
            options: { type: QueryBuilder_1.FieldType.Boolean },
        },
    },
});
exports.analysisTriggerAccessors = {
    triggerId: (trigger) => trigger.triggerId,
    lifecycleStage: (trigger) => trigger.lifecycleStage,
    runPolicy: (trigger) => trigger.runPolicy,
    subjectType: (trigger) => trigger.subjectDefinition.typeName,
    customTypeName: (trigger) => trigger.subjectDefinition.typeName === 'custom' ? trigger.subjectDefinition.customTypeName : null,
    packageId: (trigger) => trigger.subjectDefinition.typeName === 'packageStorePageModule' ? trigger.subjectDefinition.packageId : null,
    executorType: (trigger) => trigger.executor.executorType,
    agentId: (trigger) => trigger.executor.executorType === agent_executor_1.AGENT_EXECUTOR_TYPE ? trigger.executor.agentId : null,
    filterType: (trigger) => trigger.filter?.type ?? null,
    hasFilter: (trigger) => trigger.filter !== undefined,
};
exports.AnalysisTriggerSchema = zod_1.default.object({
    triggerId: zod_1.default.string(),
    lifecycleStage: lifecycle_1.AnalysisLifecycleStageSchema,
    runPolicy: lifecycle_1.AnalysisTriggerRunPolicySchema,
    subjectDefinition: exports.AnalysisTriggerSubjectDefinitionSchema,
    filter: exports.AnalysisTriggerFilterDefinitionSchema.optional(),
    executor: trigger_executor_1.TriggerExecutorSchema.passthrough(),
});
exports.AnalysisTriggerExecutionSchema = zod_1.default.object({
    executionId: zod_1.default.string(),
    triggerId: zod_1.default.string(),
    subject: exports.AnalysisTriggerSubjectSchema,
    subjectIdentity: exports.AnalysisTriggerSubjectIdentitySchema.optional(),
    context: exports.AnalysisTriggerContextSchema,
});
//# sourceMappingURL=triggers.js.map